var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: "显示图标" } },
    [
      _c("el-switch", {
        model: {
          value: _vm.optionModel.showIcon,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "showIcon", $$v)
          },
          expression: "optionModel.showIcon",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }